import About from "../components/About";
import Courses from "../components/Courses";

const Home = () => {
  return (
    <div>
      <About />
      <Courses />
    </div>
  );
};

export default Home;
